import { Link } from "react-router-dom";

export default function ClientProjectStatus({ project }) {
  if (!project) {
    return <div className="client-card"><h2>Project Overview</h2><p>No active approved project found.</p></div>;
  }

  return (
    <div className="client-card">
      <h2>Project Overview</h2>
      <h3>{project.project_name}</h3>
      <p>{project.summary || "Project details are being prepared."}</p>
      <div className="detail-row"><span>Status</span><strong>{project.current_phase || "Awaiting Assignment"}</strong></div>
      <div className="detail-row"><span>Plan</span><strong>{project.selected_plan}</strong></div>
      <div className="detail-row"><span>Project Manager</span><strong>{project.project_manager}</strong></div>
      <div className="progress-bar"><div className="progress-fill" style={{ width: `${project.progress_percentage || 0}%` }} /></div>
      <p>{project.progress_percentage || 0}% Complete</p>
      <Link className="client-link" to={`/projects/${project.id}`}>View project</Link>
    </div>
  );
}